// The equipment in words, read from the settings (never a literal list):
// the first visit's "Set up for your gym" and Settings' starting-settings
// note.
import { formatNumber } from "../lib/format";

// What the equipment items are called on screen.
const GEAR = {
  barbell: "barbell",
  rack: "squat rack",
  bench: "flat bench",
  adjustable_bench: "adjustable bench",
  cable: "cable station",
  pullup_bar: "pull-up bar",
  bands: "bands",
};

/** Each item in words: ["barbell", …, "dumbbells up to 90 lb", …]. */
export function gearList(equipment) {
  return (equipment?.items ?? []).map((item) =>
    item === "dumbbells"
      ? `dumbbells up to ${formatNumber(equipment.dumbbell_max)} ${equipment.units ?? "lb"}`
      : (GEAR[item] ?? item.replace(/_/g, " ")),
  );
}

/** "barbell, squat rack, …, dumbbells up to 90 lb, …", or "no equipment yet". */
export function gearSummary(equipment) {
  const items = gearList(equipment);
  return items.length ? items.join(", ") : "no equipment yet";
}
